import { useState } from "react";
import {
  Modal,
  TabGroup,
  Tab,
  RequestSmsPreview,
  RequestEmailPreview,
} from "@components";

export const PreviewModal = ({
  isOpen,
  onClose,
  smsSelected,
  emailSelected,
  smsMessage = "",
  emailMessage = "",
  requestedAmount,
  invoicesRequested,
  isPlainText = false,
  isBatch = false,
  customerName,
  accountCode,
}) => {
  const [tab, setTab] = useState("sms");

  const showSMS = smsSelected && (!emailSelected || tab === "sms");
  const showEmail = emailSelected && (!smsSelected || tab === "email");

  return (
    <Modal title="Message preview" isOpen={isOpen} onClose={onClose}>
      <div
        className={
          "grow min-h-[600px] bg-zinc-100 flex flex-col overflow-y-auto" +
          (!(smsSelected && emailSelected) && " py-4")
        }
      >
        {smsSelected && emailSelected && (
          <div className="w-[390px] mx-auto">
            <TabGroup>
              <Tab active={tab === "sms"} onClick={() => setTab("sms")}>
                SMS
              </Tab>
              <Tab active={tab === "email"} onClick={() => setTab("email")}>
                Email
              </Tab>
            </TabGroup>
          </div>
        )}

        {/* SMS preview */}
        {showSMS && (
          <div className="w-[390px] mx-auto flex-1">
            <RequestSmsPreview
              {...(isBatch
                ? { message: smsMessage }
                : { completeMessage: smsMessage })}
              amount={requestedAmount}
              overrideAmountToken={true}
            />
          </div>
        )}

        {/* Email preview */}
        {showEmail && (
          <div className="w-[640px] mx-auto flex-1">
            <RequestEmailPreview
              {...(isBatch
                ? { message: emailMessage }
                : { completeMessage: emailMessage })}
              amount={requestedAmount}
              customerName={customerName}
              accountCode={accountCode}
              invoicesRequested={invoicesRequested}
              isPlainText={isPlainText}
              overrideAmountToken={true}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};
